"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EItemsPerPage = void 0;
var EItemsPerPage;
(function (EItemsPerPage) {
    EItemsPerPage[EItemsPerPage["Five"] = 5] = "Five";
    EItemsPerPage[EItemsPerPage["Ten"] = 10] = "Ten";
    EItemsPerPage[EItemsPerPage["Twenty"] = 20] = "Twenty";
    EItemsPerPage[EItemsPerPage["Fifty"] = 50] = "Fifty";
    EItemsPerPage[EItemsPerPage["OneHundred"] = 100] = "OneHundred";
})(EItemsPerPage || (exports.EItemsPerPage = EItemsPerPage = {}));
